import { Outlet } from '@tanstack/react-router'
import { Navbar } from './Navbar'
import { Footer } from './Footer'

/**
 * Root layout component that wraps all routes.
 * Provides consistent navbar and footer across the application.
 */
export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
